import WatchAccessDenied from './WatchAccessDenied'

export default WatchAccessDenied
// eslint-disable-next-line import/export
export * from './WatchAccessDenied'
